<template>
  <div id="itemlist" class="overflow-auto" style="height: 800px;">
    <div style="height: 960px;">
      <div style="padding:1rem 0 0 0;" />
      <div v-if="aclist.length==0" style="margin-top:2rem;">            
          <div style="padding:2rem;">
            <span style="background-color: white;color: black;font-size: large;font-weight: bold;" v-text="'無相關活動資料, 請確認謝謝。。。'"></span>
          </div>                  
      </div>      
        <div
          v-for="(item, $index) in aclist"
          :key="$index"
          class="event-card"         
        >
          <div class="event-img-wrap">
            <img
              :src="item.url !== '' ? item.url : mainImg('event_1080x540.png')"
              alt="活動圖片"
              class="event-img"
            />
          </div>
          <div class="event-info" v-if="item.theme==selected || selected=='all' || orgid!=='N' || selected!=='N' || area!=='N'" style="cursor:pointer;" @click="toConten(item.fid)">
            <div class="event-title">{{ rename(item.actitle) }}</div>
            <div class="event-meta">
              <span class="event-type">#{{ getinfo(item.theme) }}</span>
              <span class="event-date">{{ fdateformat(item) }}</span>
            </div>
            <div class="event-more">(詳細內容...)</div>
          </div>
        </div>   
      <infinite-loading @infinite="infiniteHandler" spinner="waveDots" :distance="5">
        <span slot="no-more" v-if="info!==null">
          <div v-if="info!==null && aclist.length>0">
            <a-button v-if="info.totail>(info.page * info.results)"  style="margin: 20px;"  @click="infiniteHandler()" type="primary" shape="round" icon="download" size="large" >取得更多資料</a-button>
          </div>
          <div style="padding:2rem;">
          <span v-if="info.totail<=(info.page * info.results)" style="background-color: white;color: black;font-size: large;font-weight: bold;" v-text="'無相關活動資料, 謝謝。。。'"></span>
          </div>
        </span>
      </infinite-loading>
      <div style="padding:3.5rem 0 0 0;" />
    </div>

    <!-- 浮動式按鈕群 -->
    <div class="floating-buttons-wrap">
      <div class="floating-button floating-button--qr" @click.stop="showQrModal = true">
        <a-icon type="qrcode" class="qr-icon" />
        <span class="button-text">掃碼加入</span>
      </div>
    </div>

    <!-- QR Code Modal -->
    <a-modal
      v-model="showQrModal"
      title="掃碼加入我們"
      :footer="null"
      centered
      :bodyStyle="{ textAlign: 'center', padding: '24px 20px 28px' }"
    >
      <div class="qr-modal-content">
        <img src="../../assets/img/myqrcode.png" alt="QR Code" class="qr-modal-img" />
        <p class="qr-modal-hint">請使用 LINE 或手機相機掃描進入</p>
      </div>
    </a-modal>    
  </div>
</template>

<script>
import * as moment from "moment/moment";
import { actService } from "../../_services";
import MY_JSON from "../../assets/json/optiondata.json";
import { mapState, mapMutations } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import router from "../../router";
import store from "../../store/index";

const queryACata = obj => {
  //return actService.getactlistall(obj);
  return actService.getItemAct(obj)
};

export default {
  name: "Viewper",
  components: {
    InfiniteLoading
  },
  props: {
    msg: String,
    item: Array,
    winsize: Object
  },
  data() {
    return {
      myJson: MY_JSON,
      page: 1,
      orgid:'N',
      area:'N',
      checkgo: false,
      aclist: [],
      aclove: [],
      info:null,
      objs: {
        uid: "",
        fidlist: []
      },
      selected: "all",
      action: null,
      items: "",
      queryMyLineState:{},
      showQrModal: false,
    };
  },
  async mounted() {
    if (this.user !== null) {
      let obj = { id: "Myline" };
      await this.setorgpage(obj)
        .then(val => {
          return val;
        })
        .catch(val => {
          return val;
        })
      let names = store.state.account.targetpage;
      if (names == "Myline") {
        this.getLinecheck();
        if (this.linecheck == true) {
          const savedMyLineQueryState = JSON.parse(sessionStorage.getItem('queryMyState'));
          if (savedMyLineQueryState) {
            this.queryMyLineState = savedMyLineQueryState;
            this.page=this.queryMyLineState.page,
            this.selected=this.queryMyLineState.selected,
            this.orgid=this.queryMyLineState.orgid,
            this.area=this.queryMyLineState.area,
            this.aclist=this.queryMyLineState.aclist
            sessionStorage.removeItem('queryMyState');
          }else{            
            this.getfetch();
          } 
        }
      }
      window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
    }
  },
  computed: {
    ...mapState("account", ["user", "linecheck"])
  },

  methods: {
    ...mapMutations("account", ["setpage", "getLinecheck"]),
    fdateformat(val) {
      return (
        moment(val.sdate).format("YYYY-MM-DD HH:mm") +
        "~" +
        moment(val.edate).format("MM-DD HH:mm")
      );
    },
    catImg(imgs) {
      return require(`../../assets/img/${imgs}`);
    },
    mainImg(imgs) {
      return require(`../../assets/${imgs}`);
    },     
    getinfo(theme) {
      let url = this.myJson.find(rs => rs.value == theme).title;
      return url;
    },

    rename(value){
      return value.length >= 25 ? value.substring(0,17)+'...':value
    },

    setorgpage(obj) {
      return new Promise(resolve => {
        resolve(this.setpage(obj));
      });
    },

    getfetch() {
        this.infiniteHandler();
    },

    getxt(val) {
      return val.substring(1, 32);
    },

    ontype(val) {
      this.orgid = 'N';
      this.area = 'N';
      this.aclist=[]
      this.selected = val;
      this.page=1
      this.infiniteHandler();
    },

    onByOrg(val){
      this.orgid = val.ids;
      this.area = 'N';
      this.aclist=[]
      this.selected = 'N';
      this.page=1
      this.infiniteHandler();
    },

    getArea(val){
      this.area = val;
      this.orgid =  'N';
      this.aclist=[]
      this.selected = 'N';
      this.page=1
      this.infiniteHandler();
    },

    handleSearchActivity(val){
      this.orgid = 'N';
      this.area = 'N';
      this.aclist=[]
      this.selected = val!=='' ? 'AcTitle:'+val : val;
      this.page=1
      this.infiniteHandler();
    },

    toConten(id) {
      this.postdata(false, "");
      router.push({ name: "Myapply", params: { id } });
    },

	async infiniteHandler($state) {
      this.iconLoading = true;
      this.$emit('loads',true);
      var my_date = new Date();
      var first_date = new Date(my_date.getFullYear(), my_date.getMonth()-12, 1);

      let params = {
        page: this.page,
        size: 4,
        type: this.selected,
        date: moment(first_date).format("YYYY-MM-DD HH:mm"),
        states:'Y',
        orgid:this.orgid,
        area:this.area
      }
      let rs=await this.getRuner(params)
      if(rs){
        $state.loaded();
      }else{
        $state.complete();
      }
      if($state.loaded()==undefined){
        this.$emit('loads',false)
      }      
    }, 
    
    getRuner(params) {
      return new Promise((resolve) => {
      this.page++;
      queryACata({
        ...params
      }).then(({ data }) => {
        let obj = {
          hits: data.results
        };
        if (obj.hits == null) {
          obj.hits = [];
        }
        this.$emit('loads',false)
        if (obj.hits.length) {
          this.info = data.info
          let myData = obj.hits
          let myobj = this.myPush(myData);   
          this.aclist.push(...myobj);  
          resolve(true);
        } else {
          resolve(false);
        }
      });
      });
    }, 
    
    myPush(obj) {
        // 使用 Fisher-Yates 洗牌算法來隨機排列陣列
        for (let i = obj.length - 1; i > 0; i--) {
            //const j = Math.floor(Math.random() * (i + 1));
            const j = Math.floor(Math.random() * obj.length); // 範圍擴大到整個陣列
            [obj[i], obj[j]] = [obj[j], obj[i]]; // 交換元素位置
        }
        return obj;
    },     

    postdata(val, item) {
      this.checkgo = val;
      this.items = item;
      this.togo();
    },
    togo() {
      if (this.checkgo) {
        if (this.items == "love") {
          router.replace({ name: "Mylove" });
        } else if(this.items == "score"){
          router.replace({ name: "MyScoreData" });
        } else if (this.items == "act") {
          router.replace({ name: "Mydoing" });
        }
      }
      this.checkgo = false;
    },

    beforeunloadHandler(e) {
      console.log(e);
      this.postdata(false, "");
    },

    saveRoute(){
        this.queryMyLineState={
          page: this.page,
          selected: this.selected,
          orgid:this.orgid,
          area:this.area,
          aclist:this.aclist
      }
      sessionStorage.setItem('queryMyState', JSON.stringify(this.queryMyLineState));
    }
  },
  created() {},
  destroyed() {
    window.removeEventListener("beforeunload", e =>
      this.beforeunloadHandler(e)
    );
  },

    
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#itemlist {
  margin: 0px auto;
  padding: 0px;
  max-width: 1024px;
}

img {
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  display: block;
  clip-path: polygon(-4px -4px, 100.4% -3px, 99.2% 102.57%, -0.8% 102.97%);
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  width: min(98%, 500px);
  margin: 0 auto;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
  overflow: hidden;
}

.cards-details {
  position: relative;
  padding: 0 0.05rem 0 0.5rem;
}

.fontstyle {

  font-size: 0.93rem;
  font-weight:bold;
  color: #2c055e;
  padding: 0.4rem;
  background:linear-gradient(45deg,#7fdac1 0%,#5decde 60%,#ddf0e6 60%,#93cea2 100%);
  opacity:0.85;

}

.spin-content {
  padding: 60px;
  box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
}

.card-body{
  padding:0px;
}

.card-img-top{
  border-top-right-radius:25px;
}
.card{
  border-top-right-radius:25px;
}

.event-card {
  margin: 14px 8px 18px 8px;
  border-radius: 22px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10), 0 1.5px 6px rgba(0,0,0,0.05);
  background: #fff;
  transition: transform 0.12s, box-shadow 0.12s;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.event-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 6px rgba(0,0,0,0.09);
}
.event-img-wrap {
  width: 100%;
  aspect-ratio: 2/1;
  overflow: hidden;
  background: #f4f4f7;
}
.event-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.event-info {
  padding: 18px 16px 14px 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.event-title {
  font-size: 1.14rem;
  font-weight: 700;
  color: #20222a;
  margin-bottom: 2px;
  line-height: 1.4;
  white-space: pre-line;
}
.event-meta {
  font-size: 0.95rem;
  color: #8a8a99;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 2px;
}
.event-type {
  background: #f0f5ff;
  color: #3478f6;
  border-radius: 7px;
  padding: 2px 10px;
  font-size: 0.92em;
  font-weight: 500;
}
.event-date {
  color: #7b7b87;
  font-size: 0.91em;
  font-weight: 400;
}
.event-more {
  font-size: 0.92em;
  color: #3478f6;
  font-weight: 600;
  margin-top: 4px;
}
@media (max-width: 480px) {
  .event-card { margin: 9px 2.6vw 14px 2.6vw; }
  .event-info { padding: 14px 10px 10px 10px; }
  .event-title { font-size: 1.01rem; }
}

/* 浮動按鈕樣式 - 簡潔素雅設計 */
.floating-button {
  position: fixed !important;
  top: 50% !important;
  right: 0px !important;
  transform: translateY(-50%) !important;
  padding: 16px 10px;
  background-image: linear-gradient(to bottom left, #f7f8f8, #e9bcbc);
  border: 0px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px 0px 0px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backdrop-filter: blur(8px);
  box-shadow: 
    0 2px 12px rgba(0, 0, 0, 0.18),
    0 1px 3px rgba(0, 0, 0, 0.15);
  z-index: 2 !important;
  transition: all 0.2s ease;
  width: 48px;
  height: 120px;
  overflow: hidden;
}

.floating-button:hover {
  transform: translateY(-50%) translateY(-2px);
  background: rgba(255, 255, 255, 1);
  border-color: rgba(0, 0, 0, 0.12);
  box-shadow: 
    0 4px 20px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.08);
}

.floating-button:active {
  transform: translateY(-50%) translateY(-1px);
  box-shadow: 
    0 1px 8px rgba(0, 0, 0, 0.1),
    0 1px 2px rgba(0, 0, 0, 0.06);
}

.heartbeat-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.15;
  z-index: 1;
  animation: heartbeat 2s ease-in-out infinite;
}

.heartbeat-icon .anticon {
  font-size: 20px;
  color: #e74c3c;
}

@keyframes heartbeat {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.15;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.25;
  }
}

.floating-button .button-text {
  color: #a75656;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 2px;
  user-select: none;
  position: relative;
  z-index: 2;
  writing-mode: vertical-rl;
  text-orientation: upright;
  line-height: 1.2;
}

/* 響應式設計 */
@media (max-width: 480px) {
  .floating-button {
    padding: 12px 8px;
    width: 40px;
    height: 100px;
  }
  
  .floating-button .button-text {
    font-size: 12px;
    letter-spacing: 1.5px;
  }
  
  .heartbeat-icon .anticon {
    font-size: 16px;
  }
}

/* 哈哈檢測 Dialog 美化樣式 */
:global(.haha-redirect-dialog) {
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

:global(.haha-redirect-dialog .van-dialog__header) {
  background: transparent;
  color: white;
  font-size: 18px;
  font-weight: 700;
  padding: 24px 24px 16px;
  border-bottom: none;
}

:global(.haha-redirect-dialog .van-dialog__content) {
  background: white;
  color: #2c3e50;
  font-size: 16px;
  line-height: 1.6;
  padding: 32px 24px;
  position: relative;
  overflow: hidden;
}

:global(.haha-redirect-dialog .van-dialog__content::before) {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
  animation: shimmer 2s ease-in-out infinite;
}

:global(.haha-redirect-dialog .van-dialog__message) {
  white-space: pre-line;
  color: #34495e;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 浮動按鈕群容器 */
.floating-buttons-wrap {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 0;
  z-index: 2;
  border-radius: 14px 0 0 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* 浮動按鈕樣式 */
.floating-button {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  transform: none !important;
  padding: 16px 10px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: filter 0.2s ease, transform 0.2s ease;
  width: 48px;
  height: 120px;
  overflow: hidden;
}

.floating-button:hover {
  filter: brightness(1.06);
  transform: translateX(-2px) !important;
}

.floating-button:active {
  filter: brightness(0.95);
  transform: translateX(-1px) !important;
}

/* 哈哈機按鈕 - 粉紅暖色 */
.floating-button--haha {
  background: linear-gradient(to bottom, #f7f0f0, #e9bcbc);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* QR 按鈕 - 藍色清爽 */
.floating-button--qr {
  background: linear-gradient(to bottom, #eaf4ff, #b3d9f7);
}
.floating-button--qr .qr-icon {
  font-size: 18px;
  color: #2d7fc1;
  margin-bottom: 2px;
  position: relative;
  z-index: 2;
}
.floating-button--qr .button-text {
  color: #2d6fa0;
}

/* QR Modal 內容 */
.qr-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}
.qr-modal-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #eee;
}
.qr-modal-hint {
  margin: 0;
  font-size: 13px;
  color: #8a8a99;
  letter-spacing: 0.5px;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* 響應式調整 */
@media (max-width: 480px) {
  :global(.haha-redirect-dialog) {
    margin: 20px;
    border-radius: 16px;
  }
  
  :global(.haha-redirect-dialog .van-dialog__header) {
    font-size: 16px;
    padding: 20px 20px 12px;
  }
  
  :global(.haha-redirect-dialog .van-dialog__content) {
    font-size: 14px;
    padding: 24px 20px;
  }
}
</style>





